import { Table, Input, Button, Modal, DatePicker } from "antd";
import React, { useEffect, useState } from "react";
import { httpGet, httpUrl, httpPost } from "../../api/httpClient";
import moment from "moment";
import locale from "antd/es/date-picker/locale/ko_KR";
import excelPng from "../../img/excel.png";
import { comma } from "../../lib/util/numberUtil";

const Search = Input.Search;
const { RangePicker } = DatePicker;

const AdminLoginLog = () => {
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });
    const [list, setList] = useState([]);
    const [status, setStatus] = useState(0);
    const [date, setDate] = useState({
        start: moment().format("YYYY-MM-DD"),
        end: moment().format("YYYY-MM-DD")
      });

    useEffect(() => {
        getList();
    },[date.end, pagination.current, pagination.pageSize, date.start]);
    
    const getList = async () => {
        const endDate = moment(date.end).add(1, 'd').format("YYYY-MM-DD");
        const res = await httpGet(httpUrl.getLoginLog, [ endDate, pagination.current, pagination.pageSize, date.start ], {});
        console.log(res);        
        if (res.result === "SUCCESS" && res.data) {
            console.log(res.data.log)
            setList(res.data.log);
            setPagination({
                ...pagination,
                current: res.data.currentPage,
                total: res.data.totalCount
            })
        }
    };

    const handleTableChange = (page) => {
        if (page.current !== pagination.current) {
            setPagination({
                ...pagination,
                current: page.current
            });
        } else if (page.pageSize !== pagination.pageSize) {
            setPagination({
                ...pagination,
                current: 1,
                pageSize: page.pageSize
            });
        }
    };
    
    const columns = [
        {
            title: "로그인 일시",
            dataIndex: "createDate",
            className: "column-center",
            render : (data)=> moment(data).format("YYYY-MM-DD HH:mm:ss")
        },
        {
            title: "아이디",
            dataIndex: "id",
            className: "column-center",
        },
        {
            title: "아이피",
            dataIndex: "ipAddress",
            className: "column-center",
        },
        {
            title: "상태",
            dataIndex: "result",
            className: "column-center",
            render: (data, row) => data > 0 ? "성공" : <Button onClick={()=>failModal(row)}>실패</Button>
        },
    ];

    const failModal = (row) => {
        const reason = row.memo === 'INVALID_LOGIN_ID' 
                        ? '아이디 입력 오류'
                        :  row.memo === 'EXPIRED'
                        ? '삭제된 아이디'
                        : row.memo === 'INVALID_LOGIN_PASSWORD' 
                        ? '패스워드 입력 오류'
                        : '기타'
        Modal.error({
            title: '로그인 실패',
            content: reason,
        });
    }

    const reset =() =>{
        setStatus(0)
        setDate({
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
        })
    };

    const onChangeDate = (type) => {
        switch (type) {
            case 0 : {
                setStatus(0);
                setDate({
                    start: moment().format("YYYY-MM-DD"),
                    end: moment().format("YYYY-MM-DD")
                })
            } break;
            case 1 : {
                setStatus(1);
                setDate({
                    start: moment().add(-7, 'd').format("YYYY-MM-DD"),
                    end: moment().format("YYYY-MM-DD")
                })
            } break;
            case 2 : {
                setStatus(2);
                setDate({
                    start: moment().subtract(3, 'M').format("YYYY-MM-DD"),
                    end: moment().format("YYYY-MM-DD")
                })
            } break;
            case 3 : {
                setStatus(3);
                setDate({
                    start: moment('2023-01-01').format("YYYY-MM-DD"),
                    end: moment().format("YYYY-MM-DD")
                })
            } break;
        }
    }
    const onChangeRangePicker = (date, string) => {
        setStatus(4)
        setDate({
            start: moment(string[0]).format("YYYY-MM-DD"),
            end: moment(string[1]).format("YYYY-MM-DD")
        })
    }

    const disabledDate = (current) => {
        return current && current > moment().endOf('day');
        };

    return (
        <div className="main" id="log">
        <div className="main-title">
            로그인 로그
        </div>
            <div className="top-bar">
                <div>
                    <Button className={status === 0 && "active"}  onClick={()=>onChangeDate(0)}>
                        금일
                    </Button>
                    <Button className={status === 1 && "active"}  onClick={()=>onChangeDate(1)}>
                        1주일
                    </Button>
                    <Button className={status === 2 && "active"}  onClick={()=>onChangeDate(2)}>
                        3개월
                    </Button>
                    <Button className={status === 3 && "active"}  onClick={()=>onChangeDate(3)}>
                        전체
                    </Button>
                    <p>
                    <RangePicker
                        style={{padding:5, borderRadius:5, marginRight:10,  border:'1px solid #888',height:32}}
                        locale={locale}
                        format={"YYYY-MM-DD"}
                        allowClear={false}
                        picker="date"
                        value={[
                        moment(date.start, "YYYY-MM-DD"),
                        moment(date.end, "YYYY-MM-DD"),
                        ]}
                        onChange={onChangeRangePicker}
                        disabledDate={disabledDate}
                    />
                    </p>                  
                </div>
                 <Button onClick={()=>reset()}>
                   초기화
                </Button>
            </div>
           <div className="top-table">
                <div className="top-table-container">
                        <div>
                        총 <span> {comma(pagination.total)}</span>건이 검색되었습니다.
                        </div>
                      
                 </div>

                <Table
                    rowKey={(record) => record.idx}
                    dataSource={list}
                    columns={columns}
                    pagination={pagination}
                    onChange={handleTableChange}
                />
             </div>
        </div>
    );

}

export default AdminLoginLog;
